import { Box, Flex, Stack, Text, useColorModeValue } from '@chakra-ui/react';
import Links from 'components/sidebar/components/Links';

function SidebarContent(props: {
  routes: RoutesType[];
  hovered?: boolean;
  mini?: boolean;
}) {
  const { routes, mini, hovered } = props;
  const muted = useColorModeValue('#8a817a', 'gray.400');

  return (
    <Flex direction="column" h="100%" pt="14px" pb="18px">
      {!mini && (
        <Text px="24px" mb="10px" fontSize="11px" fontWeight="800" letterSpacing=".14em" color={muted}>
          MODULOS
        </Text>
      )}
      <Stack direction="column" mb="auto">
        <Box px={mini ? '10px' : '16px'}>
          <Links mini={mini} hovered={hovered} routes={routes} />
        </Box>
      </Stack>
      {!mini && (
        <Box mx="16px" mt="18px" p="14px" borderRadius="18px" bg="#f7efe8" border="1px solid rgba(91, 24, 43,.12)">
          <Text fontSize="xs" color="#5b182b" fontWeight="800">Ayuntamiento de Totolac</Text>
          <Text fontSize="11px" color={muted}>Sistema administrativo municipal</Text>
        </Box>
      )}
    </Flex>
  );
}

export default SidebarContent;
